const initialState = {
    submitted: false,
    message: undefined,
    profiles: [],
    hwGps: [],
    apns: [],
    locationApns: [],
    simsUpdates: [],
    backupUpdates: [],
    form: {},
    counts: {}
};

function simsReducer(state = initialState, action = {}) {
    switch (action.type) {
        case 'GET_SIM_PROFILES_REQUEST':
            return {
                ...state,
                submitted: true
            };
        case 'GET_SIM_PROFILES_SUCCESS':
            return {
                ...state,
                profiles: Object.keys(action.profiles).map((key) => ({ key, text: action.profiles[key], value: key }))
            };
        case 'GET_SIM_HW_GROUPS_SUCCESS':
            return {
                ...state,
                hwGps: action?.hwGps.map((hwGp) => ({ key: hwGp, text: hwGp, value: hwGp }))
            };
        case 'GET_SIM_APNS_SUCCESS':
            return {
                ...state,
                apns: action.apns?.map((apn) => ({
                    key: apn?.name,
                    text: apn?.name,
                    value: apn?.name,
                    ipPool: apn?.ipPool,
                    locationId: apn?.locationId,
                    locationName: apn?.locationName,
                    hasSimAllocated: apn?.hasSimAllocated
                }))
            };

        case 'GET_SIM_LOCATION_APNS_SUCCESS':
            return {
                ...state,
                locationApns: action.apns?.map((apn) => ({
                    key: apn?.name,
                    text: apn?.name,
                    value: apn?.name,
                    ipPool: apn?.ipPool,
                    locationId: apn?.locationId,
                    locationName: apn?.locationName,
                    hasSimAllocated: apn?.hasSimAllocated
                }))
            };

        case 'GET_SIM_PROFILES_API_ERROR':
            return {
                ...state,
                submitted: false
            };

        case 'SIMS_NOTIFICATION_RESPONSE':
            return {
                ...state,
                simsUpdates: action.payload
            };

        case 'BACKUP_NOTIFICATION_RESPONSE':
            return {
                ...state,
                backupUpdates: action.payload
            };

        case 'GET_SIM_COUNTS_SUCCESS':
            return {
                ...state,
                counts: action.counts
            };
        default:
            return state;
    }
}

export default simsReducer;
